import { render, staticRenderFns } from "./EditRegion.vue?vue&type=template&id=0fdf645c&scoped=true"
import script from "./EditRegion.vue?vue&type=script&lang=ts"
export * from "./EditRegion.vue?vue&type=script&lang=ts"
import style0 from "./EditRegion.vue?vue&type=style&index=0&id=0fdf645c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf645c",
  null
  
)

export default component.exports